import React from 'react';
import CinematicStage, { isCinematicScene } from '../CinematicStage.jsx';

/**
 * HUD scene zone (v3 `.sc`). Renders the real MP4 CinematicStage for the
 * current scene. ch2 keeps CinematicStage's existing hotspots/nav/bioscan
 * chrome; the chromeless split (so the v3 button-bar/left-panel own that
 * chrome) is the ch6 scene-zone refinement.
 */
export default function HudSceneZone({ sceneId, scanMode, onHotspotInteract, onNavigate, onElevatorComplete, onBioscanClick, onSceneReady, overlay }) {
  return (
    <div className="sc">
      {isCinematicScene(sceneId) && (
        <CinematicStage
          chromeless
          scanMode={scanMode}
          onHotspotInteract={onHotspotInteract}
          onNavigate={onNavigate}
          onElevatorComplete={onElevatorComplete}
          onBioscanClick={onBioscanClick}
          onSceneReady={onSceneReady}
        />
      )}
      {/* In-frame glass overlays (e.g. AUDIO) render here so .glass (absolute
          inset:0) is bounded by .sc and blocks scene hotspots. */}
      {overlay}
    </div>
  );
}
